import { Injectable, inject } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoginModel } from '../../core/models/auth/login.model';
import { RegisterModel } from '../../core/models/auth/register.model';
import { UserModel } from '../../core/models/user/user.model';
import {
  NotificationType,
  ShiveNotificationService,
} from '../../core/services/controls/shive-notification.service';
import * as fromAuthActions from './auth.actions';

@Injectable({
  providedIn: 'root',
})
export class AuthHttpService {
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);
  private readonly shiveNotificationService = inject(ShiveNotificationService);

  constructor() {
    this.initHttpCallbacks();
  }

  public login(loginModel: LoginModel): Observable<LoginModel> {
    this.store.dispatch(
      fromAuthActions.loginUser({
        payload: loginModel,
      }),
    );

    return this.actions$.pipe(ofType(fromAuthActions.userLoggedIn));
  }

  public authenticate(): Observable<UserModel> {
    this.store.dispatch(fromAuthActions.fetchLoggedInUser());

    return this.actions$.pipe(
      ofType(fromAuthActions.setLoggedInUser),
      map((result) => result.payload),
    );
  }

  public register(registerModel: RegisterModel): Observable<RegisterModel> {
    this.store.dispatch(
      fromAuthActions.registerUser({
        payload: registerModel,
      }),
    );

    return this.actions$.pipe(ofType(fromAuthActions.userRegistered));
  }

  public logout(): Observable<unknown> {
    this.store.dispatch(fromAuthActions.logoutUser());

    return this.actions$.pipe(ofType(fromAuthActions.userLoggedOut));
  }

  public unauthorized(): Observable<unknown> {
    return this.actions$.pipe(ofType(fromAuthActions.unauthorized));
  }

  private initHttpCallbacks(): void {
    this.actions$.pipe(ofType(fromAuthActions.userRegistered)).subscribe(() => {
      this.shiveNotificationService.show(NotificationType.Success);
    });
  }
}
